import React, { ReactNode, forwardRef, useRef, useImperativeHandle } from 'react';

import cx from '../../utils/classnames';

import styles from './dialogContent.module.scss';

type Props = {
  className?: string;
  children: ReactNode;
};

const DialogContent = forwardRef((props: Props, ref) => {
  const innerRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(ref, () => ({
    focus: () => {
      innerRef.current?.getElementsByTagName('input')[0]?.focus();
    },
  }));

  return (
    <div
      data-testid="dialog-content"
      className={cx(props.className, styles.content)}
      ref={innerRef}
    >
      {props.children}
    </div>
  );
});

export default DialogContent;
